import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppBBWaardecheckAppraisalRequestNewCondition =
  (): DescribeNodeType =>
    'een nieuwe brainbay waardecheck - waardebepaling is aangevraagd';

export default describeAppBBWaardecheckAppraisalRequestNewCondition;
